enum ServiceConfigKey {
  MigrationClickUrl = 'migrationClickUrl',
  MigrationPostbackUrl = 'migrationPostbackUrl',
  AppsflyerEncrptionKey = 'appsflyer_encription_key',
  AppsflyerAppList = 'appsFlyerAppList',
  AppsflyerApiToken = 'appsFlyerPullApiToken',
  MailHost = 'mailHost',
  MailPort = 'mailPort',
  MailUsername = 'mailUsername',
  MailPassword = 'mailPassword',
  MailFrom = 'mailFrom',
  VTAOverride = 'vtaOverride',
  ShowOfferBudgets = 'showOfferBudgetsWhenNoPublisherBudgetsAvailable',
  Currency = 'platformDefaultCurrency',
  Timezone = 'defaultTimezone',
}

export const ServiceConfigKeyLabel = {
  [ServiceConfigKey.MigrationClickUrl]: 'Click URL',
  [ServiceConfigKey.MigrationPostbackUrl]: 'Postback URL',
  [ServiceConfigKey.AppsflyerEncrptionKey]: 'Encryption Key',
  [ServiceConfigKey.AppsflyerAppList]: 'Apps',
  [ServiceConfigKey.AppsflyerApiToken]: 'API Token',
  [ServiceConfigKey.MailHost]: 'Host',
  [ServiceConfigKey.MailPort]: 'Port',
  [ServiceConfigKey.MailUsername]: 'Username',
  [ServiceConfigKey.MailPassword]: 'Password',
  [ServiceConfigKey.MailFrom]: 'From',
  [ServiceConfigKey.VTAOverride]: 'View Through Attribution',
  [ServiceConfigKey.ShowOfferBudgets]: 'Show Offer Budgets',
  [ServiceConfigKey.Currency]: 'Currency',
  [ServiceConfigKey.Timezone]: 'Timezone',
};

export default ServiceConfigKey;
